import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vModelDynamic as _vModelDynamic, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fb8bb40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error-info"
}
const _hoisted_2 = ["type", "placeholder", "inputmode", "disabled", "maxlength", "autocapitalize"]
const _hoisted_3 = { class: "error-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input-component", { 'error-icon-select': _ctx.hasError }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(["field-label", { disabled: _ctx.disabled }])
        }, [
          (_ctx.requiredSign)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
            : _createCommentVNode("", true),
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ], 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "x-mark-icon", {}, undefined, true),
    _withDirectives(_createElementVNode("input", {
      id: "baseInput",
      class: _normalizeClass({ 'has-error': _ctx.hasError && !_ctx.disabled, 'icon-after': _ctx.iconAfter }),
      type: _ctx.type,
      placeholder: _ctx.placeholder,
      inputmode: _ctx.inputmode,
      disabled: _ctx.disabled,
      maxlength: _ctx.maxLength,
      autocapitalize: _ctx.autocapitalize,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      onCompositionupdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.compositionUpdate($event))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus'))),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('blur'))),
      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('change'))),
      onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('keyup', this.value))),
      onKeydown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('keydown'))),
      tabindex: "0"
    }, null, 42, _hoisted_2), [
      [_directive_maska, _ctx.mask],
      [_vModelDynamic, _ctx.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
    ], 512), [
      [_vShow, _ctx.hasError && !_ctx.disabled]
    ])
  ], 2))
}